__turbopack_context__.v({
  "button": "index-module-scss-module__JADfHW__button",
  "error": "index-module-scss-module__JADfHW__error",
  "errorBox": "index-module-scss-module__JADfHW__errorBox",
  "form": "index-module-scss-module__JADfHW__form",
  "formHeader": "index-module-scss-module__JADfHW__formHeader",
  "label": "index-module-scss-module__JADfHW__label",
  "selected": "index-module-scss-module__JADfHW__selected",
  "termsAndConditions": "index-module-scss-module__JADfHW__termsAndConditions",
  "vatBox": "index-module-scss-module__JADfHW__vatBox",
});
